module.exports = __webpack_public_path__ + "img/thumbnail_AmericanAlligator_f_normal.49c5ddd0.png";